import { getRTFInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { Link } from "gatsby";
import React from "react";
import { Trans } from "react-i18next";
import { RTF } from "../elements/RTF";
import { Visual } from "../shared/Visual";
import { SectionPaddingClassName } from "../styles";
import { getVisual } from "./Blocks";

export const KeyFeatures: React.FC<{
  collection: Queries.CollectionFragment;
}> = ({ collection: { displayTitle, showTitle, contents } }) => {
  const keyFeatureContents = contents.filter(
    (cb) => cb.__typename === "GraphCMS_ContentBlock"
  ) as Array<Queries.ContentBlockFragment>;
  return (
    <section
      data-component="Key Features"
      className={classNames(
        SectionPaddingClassName,
        "page-grid max-width relative"
      )}
    >
      <div className="dashed-line col-span-4 col-start-2 mb-30px text-lazer md:col-span-8 md:col-start-2 md:mb-50px lg:col-span-12 lg:col-start-3 lg:mb-75px" />
      {showTitle && displayTitle && (
        <h3 className="h3 col-span-4 col-start-2 mb-60px text-coal md:col-span-8 md:col-start-2 md:mb-100px lg:col-span-12 lg:col-start-3 lg:mb-150px">
          {displayTitle}
        </h3>
      )}
      <div className="col-span-4 col-start-2 grid grid-cols-4 gap-x-mobile gap-y-24 md:col-span-8 md:col-start-2 md:grid-cols-12 md:gap-x-tablet lg:col-span-12 lg:col-start-3 lg:gap-x-desktop">
        {keyFeatureContents.map((service, index) => {
          const { title, image, message, internalLink } = service;
          const cleaned = getRTFInformation(message);

          const pageTypePath = `/${
            internalLink?.pageType ? internalLink.pageType + "/" : ""
          }${
            internalLink?.slug === "index"
              ? ""
              : internalLink?.slug
              ? internalLink.slug
              : ""
          }`;
          const prefix = `/${internalLink?.locale ?? "en"}`;
          const path = `${prefix}${pageTypePath}`;
          return (
            <div key={index} className="col-span-full md:col-span-4">
              <div
                className={classNames(
                  index % 2 == 0 ? "mt-0 md:mt-150px" : "mt-0",
                  "flex flex-col gap-10"
                )}
              >
                <Visual
                  visual={getVisual(image)}
                  sizes="(max-width: 767px) 100vw, 395px"
                />
                <div className="flex flex-col gap-5">
                  <h3 className="h8">{title}</h3>
                  {cleaned && <RTF content={cleaned} className="bullets" />}
                </div>
                {internalLink && (
                  <Link className="servicesButton lg:mt-5" to={path}>
                    {internalLink?.linkTitle ?? <Trans>Learn more</Trans>}
                  </Link>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
